import Chip from '@mui/material/Chip';
import type { BillSummary } from '../billing.api';

const LABELS: Record<string, { label: string; color: 'default' | 'success' | 'warning' | 'error' | 'info' }> = {
  PAID: { label: 'Paid', color: 'success' },
  PARTLY_PAID: { label: 'Part paid', color: 'warning' },
  UNPAID: { label: 'Unpaid', color: 'error' },
  ACTIVE: { label: 'Open', color: 'info' },
  ADVANCE_RECEIVED: { label: 'Advance received', color: 'success' },
  CONVERTED: { label: 'Converted to bill', color: 'default' },
  CANCELLED: { label: 'Cancelled', color: 'default' },
};

/** Paid / Part paid / Unpaid for a bill; Open / Advance received / Converted for a proforma; Cancelled for either. */
export function BillStatusChip({ bill }: { bill: Pick<BillSummary, 'paymentStatus'> }) {
  const s = LABELS[bill.paymentStatus] ?? { label: bill.paymentStatus, color: 'default' as const };
  return <Chip size='small' label={s.label} color={s.color} variant={s.color === 'default' ? 'outlined' : 'filled'} />;
}
